import { render, staticRenderFns } from "./CopyStakeWheelOfFortuneCampaignDialog.vue?vue&type=template&id=1fc59d28&scoped=true&lang=pug"
import script from "./CopyStakeWheelOfFortuneCampaignDialog.vue?vue&type=script&lang=ts"
export * from "./CopyStakeWheelOfFortuneCampaignDialog.vue?vue&type=script&lang=ts"
import style0 from "./CopyStakeWheelOfFortuneCampaignDialog.vue?vue&type=style&index=0&id=1fc59d28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc59d28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCardActions,VCol,VRow,VSpacer,VTab,VTabItem,VTabs,VTabsItems})
